<script>
import { VTextField } from 'vuetify/lib';

export default {
  name: 'FieldNativeSelect',
  extends: VTextField,

  props: {
    items: {
      type: Array,
      required: true,
    }
  },

  methods: {
    genInput() {
      const listeners = Object.assign({}, this.listeners$)
      delete listeners['change'] // Change should not be bound externally

      return this.$createElement('select', {
        style: {},
        domProps: {
          value: this.lazyValue,
        },
        attrs: {
          ...this.attrs$,
          autofocus: this.autofocus,
          disabled: this.disabled,
          id: this.computedId,
          readonly: this.readonly,
        },
        on: Object.assign(listeners, {
          blur: this.onBlur,
          input: this.onInput,
          focus: this.onFocus,
          keydown: this.onKeyDown,
        }),
        ref: 'input',
      }, this.genOptions());
    },

    genOptions() {
      const items = ['', ...this.items];
      return items.map(item => {
        return this.$createElement('option', {
          domProps: {
            innerHTML: typeof item == 'object' ? item.text : item,
            value: typeof item == 'object' ? item.value : item,
          }
        });
      });
    }
  }
}
</script>

<style scoped>
  .v-input 
  {
    position: relative;
  }
  select {
    /* position: absolute; */
    /* z-index: 1; */
    width: 100%;
    height: 42px;
    color: #1a1a1a;
    cursor: pointer;
    -webkit-appearance: none;
    appearance: none;
  }
  option 
  {
    color: #1a1a1a;
  }

  select:focus {
    outline: none;
  }

  >>> .v-input__append-outer {
    position: absolute;
    right: 0;
  }
</style>